import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { Employee } from '../../class/employee';

@Injectable()
export class EmployeeService extends WebService {

    public getEmployee (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[], _with?: string): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        if(_with != '' && _with != undefined && _with != null )
          params.append('_with', String(_with));

        const options = new RequestOptions({search: params, headers: this.headers});


        return this.http.get( `${this.apiUrl}/employee?${params}`, options);
    }
    public getEmployeeLow (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        // if (page !== null && page !== undefined) {
        //     params.append('_page', String(page));
        // } else {
        //     params.append('_page', '1');
        // }

        // if (per_page !== null && per_page !== undefined) {
        //     params.append('_limit', String(per_page));
        // } else {
        //     params.append('_limit', '10');
        // }

        // if (sort !== null && sort !== undefined) {
        //     params.append('_sort', String(sort));
        // }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        // params.append('_with', String('department.venue.company,venue.company,stations,employee_position,user,companies'));

        const options = new RequestOptions({search: params, headers: this.headers});


        return this.http.get( `${this.apiUrl}/employee-low?${params}`, options);
    }

    public newEmployee(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/employee`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateEmployee(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/employee/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteEmployee(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/employee/${id}`, { headers: this.headers } );
    }

    public infoEmployee(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/employee?id=${id}`,  { headers: this.headers } );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/employee/employee.service.ts